import React, { useContext } from 'react';
import { StyleSheet, View } from 'react-native';
import { ThemeContext } from '..';

const DEFAULT_DIMENSION = 50;

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    borderRadius: DEFAULT_DIMENSION / 2,
    height: DEFAULT_DIMENSION,
    justifyContent: 'center',
    width: DEFAULT_DIMENSION,
  },
});

interface IconBadgeProps {
  backgroundColor: string;
  dimension?: number;
  iconName: string;
  iconSize?: number;
  reverse?: boolean;
}

export const IconBadge = ({
  backgroundColor,
  dimension,
  iconName,
  iconSize = 24,
  reverse = false,
}: IconBadgeProps): React.JSX.Element=> {
  const theme = useContext(ThemeContext);
  const { IconComponent } = theme;

  const dimensionStyle = dimension
    ? {
        height: dimension,
        width: dimension,
        borderRadius: dimension / 2,
      }
    : {};

  return (
    <View style={[styles.container, { backgroundColor: backgroundColor }, dimensionStyle]}>
      <IconComponent
        color="white"
        name={iconName}
        size={iconSize}
        style={{ transform: [{ scaleX: reverse ? -1 : 1 }] }}
      />
    </View>
  );
};
